module.exports = __webpack_public_path__ + "static/media/step4.3b28d0f7.webp";